import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { ComponentProps } from '@/types';

interface LayoutProps extends ComponentProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children, className }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="h-screen flex overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
        currentPath={location.pathname}
      />

      {/* Main content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          title={getPageTitle(location.pathname)}
        />

        {/* Main content */}
        <main className="flex-1 overflow-y-auto">
          <div className={`container mx-auto px-6 py-8 ${className || ''}`}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

function getPageTitle(pathname: string): string {
  const titles: Record<string, string> = {
    '/': 'Dashboard',
    '/orders': 'Orders Management',
    '/systems': 'System Overview',
    '/agents': 'AI Agents',
    '/workflows': 'Agent Workflows',
    '/monitoring': 'System Monitoring',
  };

  // Handle dynamic routes
  if (pathname.startsWith('/systems/')) {
    const systemType = pathname.split('/')[2];
    return `${systemType.toUpperCase()} System Details`;
  }
  
  if (pathname.startsWith('/agents/')) {
    const agentType = pathname.split('/')[2];
    return `${agentType} Agent Details`;
  }
  
  if (pathname.startsWith('/workflows/')) {
    return 'Workflow Details';
  }

  return titles[pathname] || 'NEXUS V3';
}

export default Layout;
